export function initNearItinerariesSlider() {
	const el = document.querySelector(".near-itineraries-slider");
	if (!el) return;

	const slider = new Splide(el, {
		type: "slide",
		perPage: 2,
		rewind: true,
		speed: 600,
		autoplay: false,
		arrows: true,
		pagination: false,
		breakpoints: {
			1024: { perPage: 2 },
			640:  { perPage: 1 },
		},
	});
	slider.mount();
}
